//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Builder.js";
import "../no/SelectBodyList.js";
import "../no/SelectObjectList.js";
let d=[[[0,"AddRaft",1,0],[0,"AddSupport",1,0],[1,"Bodies",0,"SelectBodyList",0],[0,"InFillPrint",1,0],[0,"LocationCoordinateSystem",1,"CoordinateSystem",0],[0,"PrinterText",1,0],[0,"QualityPrint",1,0]],[],[]];
SPLM.Print3dBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Print3dBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Print3dBuilder.PrintQualityEnum = Object.freeze({
    "High" : "High", "Medium" : "Medium", "Draft" : "Draft"});

SPLM.Print3dBuilder.PrintInfillEnum = Object.freeze({
    "Hollow" : "Hollow", "Low" : "Low", "Medium" : "Medium", "High" : "High", "Solid" : "Solid"});

export default SPLM;